import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { AIConfig, AIConfigPosition } from '../../models/ai-config.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-chat-window',
  templateUrl: './ai-chat-window.component.html',
  styleUrls: ['./ai-chat-window.component.less'],
})
export class AIChatWindowComponent implements OnChanges {
  @Input() config: AIConfig;
  @Input() isOpen: boolean = true;
  @Output() closeChat = new EventEmitter<void>();

  safeIframeUrl: SafeResourceUrl;
  position: string;
  isMaximized: boolean = false;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] && this.config) {
      if (this.config['iframeUrl']) {
        this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.config['iframeUrl'],
        );
      }

      // Set position based on config
      this.position = this.config.position || AIConfigPosition.BOTTOM_RIGHT;
    }
  }

  toggleMaximize(): void {
    this.isMaximized = !this.isMaximized;
  }

  close(): void {
    this.closeChat.emit();
  }
}
